var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:( _obj = {
    'test-badge': true,
    rounded: true
  }, _obj[_vm.status] = _vm.status, _obj ),on:{"click":_vm.goToPlans}},[(_vm.remaining <= 1)?_c('i',{staticClass:"fa fa-circle-exclamation"}):_vm._e(),_vm._v(" "),(_vm.remaining >= 2)?_c('i',{staticClass:"far fa-clock"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }